<template>
<flex-row>
  <flex-fixed>
    <card-item-left :title="item.title" :bgSrc="item.bgSrc" :desc="item.desc" :link="item.id"></card-item-left>
  </flex-fixed>
  <flex-fill class="card-item-right">
    <flex-row v-for="(v) in item.documentList" :key="v.id" class="item-detail">
      <flex-fill style="overflow:hidden">
        <flex-row style="overflow:hidden">
          <flex-col style="margin-top:2px">
            <eco-icon :name="v.fileType" :size="20" class="item-icon"></eco-icon>
          </flex-col>
          <flex-col style="overflow:hidden"><a class="item-title" :title="v.title" @click="toDesc(v.id)">{{v.title}}</a></flex-col>
        </flex-row>

      </flex-fill>
      <flex-fixed class="item-detail-label">
        <eco-icon name="see" :size="16"></eco-icon> {{v.pageviews}}
        <a-divider type="vertical" />
        <span v-if="v.fileSize"><eco-icon name="download1" :size="16"></eco-icon>  {{v.downCount}}
          <a-divider type="vertical" />
        </span> 
        <span v-if="v.fileSize">{{v.fileSize}}
          <a-divider type="vertical" />
        </span> 
        {{v.createTime}}
      </flex-fixed>
    </flex-row>
  </flex-fill>
</flex-row>
</template>

<script>
import CardItemLeft from './CardItemLeft.vue'
export default {
  components: {
    CardItemLeft
  },
  props: {
    item: {
      type: Object,
      default: []
    }
  },
  methods: {
    toDesc(id) {
      this.$router.push(``);
      window.open(`/vip/details/${id}`)
    }
  },
}
</script>

<style lang="scss" scoped>
.card-item-right {
  padding: 24px 0 24px 24px;
  color: rgba(0, 0, 0, 0.8500);
  overflow: hidden;

  .item-detail {
    padding: 12px 0;

    .item-icon {
      margin-right: 8px;
      vertical-align: inherit;
    }

    .item-title {
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      height: 24px;
      display: block;
      padding-right: 32px;
      @include single-line-ellipsis();
    }

    .item-detail-label {
      min-width: 180px;
      text-align: right;
      font-size: 14px;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.4500);
      line-height: 24px;
      height: 24px;
    }
  }
}
</style>
